<template>
  <div class="musicbox">
    <div v-if="info.music!='' || info.music.length!=0" class="music" :class="playStatus?'play':''" @click="play()">
      <audio autoplay="autopaly" loop="loop" id="audios">
        <source :src="info.music.image" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')).setting,
        playStatus:false,
        isWeixin:false,
        show:false,
        pc:sessionStorage.getItem('OSType')
      }
    },
    created(){
      //typeof obj === Object
      if(typeof this.info.music === Object){
        this.show=true
      }
      this.isWeixin=sessionStorage.getItem('isWeixin')=='true'?true:false
    },
    mounted(){
      if(this.isWeixin && this.info.music){
        this.audioAutoPlay('audios')
      }
    },
    methods:{
      //播放与暂停
      play(){
        if(this.isWeixin){
          this.playStatus?document.getElementById('audios').pause():document.getElementById('audios').play()
          this.playStatus=!this.playStatus
        }
      },
      //自动播放
      audioAutoPlay(id){
        if(this.info.music==''){
          return
        }
        var audio = document.getElementById(id),
        play = function(){  
          audio.play();  
          document.removeEventListener("touchstart",play, false);  
        };  
        document.addEventListener("WeixinJSBridgeReady", function () {  
          play();  
        }, false);  
        document.addEventListener('YixinJSBridgeReady', function() {  
          play();  
        }, false);  
        document.addEventListener("touchstart",play, false);  
        this.playStatus=true
      }
    }
  }
</script>

<style lang="less" scoped>
.musicbox{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 10rem;
  margin: auto;
  z-index: 222;
  .music{
    width: .6666667rem;
    height: .6666667rem;
    display: inline-block;
    background: url('@/assets/img/music22.png');
    background-size: 100% 100%;
    position: absolute;
    top: 1.2rem;
    right: .4rem;
    z-index: 9999;
  }
  .play{
    background: url('@/assets/img/music11.png');
    background-size: 100% 100%;
    animation: music 4s infinite linear;
  }
}

//播放动画
@keyframes music {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>